import { StateCreator } from 'zustand';
import { SceneActions, GalaxyStore, Vector3 } from '../types';

export interface SceneSlice extends SceneActions {}

export const createSceneSlice: StateCreator<
  GalaxyStore,
  [],
  [],
  SceneSlice
> = (set) => ({
  // Actions only - state is defined in main store
  updateDysonSphere: (progress: number) => set((state) => {
    return {
      ...state,
      scene: {
        ...state.scene,
        dysonSphereProgress: Math.min(Math.max(progress, 0), 1), // Clamp between 0 and 1
      },
    };
  }),

  updateShipPosition: (txId: string, position: Vector3) => set((state) => {
    // Find the transaction
    const tx = state.blockchain.transactions.get(txId);
    if (!tx) return state;
    
    const newTransactions = new Map(state.blockchain.transactions);
    newTransactions.set(txId, { ...tx, currentPosition: position });
    
    return {
      ...state,
      blockchain: {
        ...state.blockchain,
        transactions: newTransactions,
      },
    };
  }),

  registerPlanetPosition: (height: number, position: Vector3) => set((state) => {
    const newPlanetPositions = new Map(state.scene.planetPositions);
    newPlanetPositions.set(height, position);
    
    return {
      ...state,
      scene: {
        ...state.scene,
        planetPositions: newPlanetPositions,
      },
    };
  }),

  unregisterPlanet: (height: number) => set((state) => {
    const newPlanetPositions = new Map(state.scene.planetPositions);
    newPlanetPositions.delete(height);
    
    return {
      ...state,
      scene: {
        ...state.scene,
        planetPositions: newPlanetPositions,
      },
    };
  }),
});